import { Component, OnInit, Input, ElementRef, Output, EventEmitter, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { Game, VideoGame, VideoGameSettings, GameSettings } from '../../_models/game';
import { GameService } from '../../services/game.service';
import { GameVideo } from '../../_models/model';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../services/config.service';
import { AudioPlayerService } from '../../services/audio-player.service';
import { transition } from '@angular/animations';
import { IGameComponent } from '../game/game.component';

@Component({
  selector: 'app-game-video',
  templateUrl: './game-video.component.html',
  styleUrls: ['./game-video.component.less']
})
export class GameVideoComponent implements OnInit, OnDestroy, IGameComponent<GameVideo> {
  private activeGame?: GameVideo;
  private activeGameId?: number;
  private levelId?: number;
  private gameId?: number;
  public videoUrl?: string;
  private totalTime: number = 0;
  @Output() closeEvent = new EventEmitter<boolean>();
  @ViewChild('videoel') videoel!: ElementRef<HTMLVideoElement>;
  playing = false;
  showControls = true;
  progress = 0;
  progressEndStyle = {
    left: '0px',
    transition: ''
  }
  progressLineStyle = {
    width: '0%',
    transition: ''
  }
  constructor(
    private gameService: GameService,
    private _changeDetectionRef: ChangeDetectorRef,
    private configService: ConfigService,
    public audio: AudioPlayerService
  ) {
  }
  ngOnDestroy(): void {
    // this.videoel.nativeElement.removeEventListener('play', this.playStarted.bind(this));
    // this.videoel.nativeElement.removeEventListener('pause', this.paused.bind(this));
  }
  suspend(event: Event) {
    // console.log('suspend', event);
  }
  waiting(event: Event) {
    // console.log('waiting', event);
    this.progressLineStyle = {
      width: (this.progress) + '%',
      transition: 'width ' + 0 + 's linear'
    }
    this.progressEndStyle = {
      left: (this.progress) + '%',
      transition: 'left ' + 0 + 's linear'
    }
  }
  emptied(event: Event) {
    // console.log('emtied', event);
  }
  stalled(event: Event) {
    // console.log('stalled', event);
  }
  playingEvent(event: Event) {
    // console.log('playing', event);
    this.progress = Math.round(this.videoel.nativeElement.currentTime) / this.videoel.nativeElement.duration * 100;
    const timeLeft = this.videoel.nativeElement.duration - this.videoel.nativeElement.currentTime;
    this.progressLineStyle = {
      width: (this.progress) + '%',
      transition: 'width ' + 0 + 's linear'
    }

    this.progressEndStyle = {
      left: (this.progress) + '%',
      transition: 'left ' + 0 + 's linear'
    }

    window.requestAnimationFrame(() => {
      this.progressLineStyle = {
        width: '100%',
        transition: 'width ' + timeLeft + 's linear'
      }

      this.progressEndStyle = {
        left: 'calc(100% - 1.2em)',
        transition: 'left ' + timeLeft + 's linear'
      }
    })
  }

  public setGame(game: GameVideo) {
    this.activeGame = game;
    this.videoUrl = this.configService.getStaticUri() + this.activeGame.video;
    this._changeDetectionRef.detectChanges();
  }

  formatTime(timeInSeconds: number) {
    const result = new Date(timeInSeconds * 1000).toISOString().substring(11, 8);

    return {
      minutes: result.substring(3, 2),
      seconds: result.substring(6, 2),
    };
  };

  ngOnInit() {
    // this.videoel.nativeElement.addEventListener('play', this.playStarted.bind(this));
    // this.videoel.nativeElement.addEventListener('pause', this.paused.bind(this));
  }

  playStarted($event :Event) {
    // console.log('playStarted', event);
  }
  // seekState: 'none' | 'start' | 'seeking' = 'none';
  // mouseDown(event: MouseEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   event.stopImmediatePropagation();
  //   this.seekState = 'start';
  // }
  // mouseUp(event: MouseEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   event.stopImmediatePropagation();
  //   this.seekState === 'none'

  // }
  // mouseMove(event: MouseEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   event.stopImmediatePropagation();
  //   event.st
  //   console.log('mouseMove', event, this.seekState);
  //   if (this.seekState == 'none') {
  //     return;
  //   }
  //   this.seek(event);
  // }
  // mouseLeave(event: MouseEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   event.stopImmediatePropagation();
  //   if (this.seekState !== 'start') {
  //     return;
  //   }
  //   this.seekState = 'none';
  // }


  seek(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const progressElement = event.target;
    // console.log('progressElement', progressElement);
    if (!(progressElement instanceof HTMLElement)) {
      console.error('progressElement is not an HTMLElement', progressElement);
      return;
    }
    const rect = progressElement.getBoundingClientRect();
    const offsetX = event.clientX - rect.left; // Get the X coordinate relative to
    const width = rect.width; // Get the width of the progress bar
    const percentage = offsetX / width; // Calculate the percentage of the click position
    const newTime = percentage * this.videoel.nativeElement.duration; // Calculate the new time in seconds
    this.videoel.nativeElement.currentTime = newTime; // Set the video's current time
    this.progress = Math.round(this.videoel.nativeElement.currentTime) / this.videoel.nativeElement.duration * 100;
    this.updateProgressLine();
  }

  paused() {

    this.progress = Math.round(this.videoel.nativeElement.currentTime) / this.videoel.nativeElement.duration * 100;
    this.updateProgressLine();

    if (this.activeGame) {
      if (this.progress < 100) {
        // Store level progress during playback
        const currState = this.gameService.getGameCompletedStatus(this.activeGame.levelNumber, this.activeGame.levelElement.step);
        const data = {progress: Math.round(this.progress * 100)}
        this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, JSON.stringify(data), currState);
      }
    }
  }

  private updateProgressLine() {
    this.progressLineStyle = {
      width: (this.progress) + '%',
      transition: 'width ' + 0 + 's linear'
    }

    this.progressEndStyle = {
      left: (this.progress) + '%',
      transition: 'left ' + 0 + 's linear'
    }
  }

  ended() {
    if (this.activeGame === undefined) {
      throw Error('no active game loaded when ended');
    }

    this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, '', true);
    this.close(true);
  }

  play() {
    if (!this.playing) {
      this.audio.stopMusic();
      this.playing = true;
      this.videoel.nativeElement.play();
      this.showControls = false;
    } else {
      this.pause();
      // this.paused();
    }


  }

  skip() {
    if (!this.playing) {
      this.audio.stopMusic();
      this.playing = true;
      // this.videoel.nativeElement.play();
      this.showControls = false;
    } else {
      this.pause();
      // this.paused();
    }
    if (this.activeGame === undefined) {
      throw Error('no active game loaded when ended');
    }

    // Go to last 2 seconds of the video
    this.videoel.nativeElement.pause();
    this.videoel.nativeElement.currentTime = this.videoel.nativeElement.duration - 2;
    this.progress = Math.round(this.videoel.nativeElement.currentTime) / this.videoel.nativeElement.duration * 100;
    this.updateProgressLine();
    this.play();

    // this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, '', true);
    // this.close(true);


  }

  restart() {
    this.pause();
    this.videoel.nativeElement.currentTime = 0;
    this.play();
  }

  close(shouldShowFinished: boolean = false) {
    this.playing = false;
    this.videoel.nativeElement.pause();
    this.closeEvent.emit(shouldShowFinished);
  }

  pause() {
    this.playing = false;
    this.videoel.nativeElement.pause();
    this.showControls = true;


  }

}
